/* CleverSteps Storefront — 인트로 · 스크롤 리빌 · 스티키 스텝
   Shopify 이식 시 theme.js 또는 커스텀 섹션 스크립트로 이동 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0. 인트로 (세션 1회) ---------- */
  var intro = document.getElementById('intro');
  if (intro) {
    var seen = false;
    try { seen = sessionStorage.getItem('cs_intro') === '1'; } catch (e) {}

    if (seen || reduce) {
      intro.remove();
    } else {
      document.body.classList.add('lock', 'intro-on');
      var bar = document.getElementById('introBar');
      var num = document.getElementById('introNum');
      var DUR = 2400;                      // 카운터 진행 시간 (로고가 다 나타난 뒤 종료)
      var start = performance.now();

      var tick = function (now) {
        var p = Math.min((now - start) / DUR, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        if (bar) bar.style.width = (eased * 100).toFixed(1) + '%';
        if (num) num.textContent = String(Math.round(eased * 100)).padStart(2, '0');
        if (p < 1) { requestAnimationFrame(tick); } else { close(); }
      };

      var closed = false;
      var close = function () {
        if (closed) return;
        closed = true;
        try { sessionStorage.setItem('cs_intro', '1'); } catch (e) {}
        intro.classList.add('done');
        document.body.classList.remove('lock', 'intro-on');
        setTimeout(function () { intro.remove(); }, 1350);
      };

      requestAnimationFrame(tick);
      intro.addEventListener('click', close);                       // 클릭 스킵
      window.addEventListener('keydown', function (e) {             // Esc/Space 스킵
        if (e.key === 'Escape' || e.key === ' ') close();
      });
    }
  }

  /* ---------- 1. 헤더 — 히어로를 지나면 solid
     히어로가 sticky라 화면에서 사라지지 않으므로 IntersectionObserver 대신 스크롤 위치로 판정한다 ---------- */
  var hdr = document.getElementById('hdr');
  var hero = document.querySelector('.hero');
  if (hdr) {
    var alwaysSolid = document.body.classList.contains('page-sub') || !hero;   // 하위 페이지는 항상 solid
    var syncHeader = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      hdr.classList.toggle('solid', alwaysSolid || y > window.innerHeight * 0.72);
    };
    window.addEventListener('scroll', syncHeader, { passive: true });
    window.addEventListener('resize', syncHeader);
    syncHeader();
  }

  /* ---------- 2. 스크롤 리빌 ---------- */
  var rv = document.querySelectorAll('.rv, .lines');
  if (!('IntersectionObserver' in window) || reduce) {
    rv.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2-a. 히어로 영상 — 네 컷을 이어서 재생하고 마지막 프레임 유지 ---------- */
  var heroVideo = document.getElementById('heroVideo');
  var clips = [heroVideo,
               document.getElementById('heroVideo2'),
               document.getElementById('heroVideo3'),
               document.getElementById('heroVideo4')].filter(Boolean);
  if (heroVideo) {
    if (reduce) {                       // 모션 최소화 설정: 재생하지 않고 poster만
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
    } else {
      var tryPlay = function (v) {
        if (!v) return;
        var pr = v.play();
        if (pr && pr.catch) { pr.catch(function () {}); }
      };
      tryPlay(heroVideo);

      clips.forEach(function (v, i) {
        var next = clips[i + 1];
        if (!next) return;
        // 다음 컷을 미리 받아둔다 (전환이 끊기지 않도록)
        v.addEventListener('timeupdate', function preload() {
          if (v.duration && v.currentTime > v.duration - 2) {
            v.removeEventListener('timeupdate', preload);
            next.preload = 'auto';
            next.load();
          }
        });
        v.addEventListener('ended', function () {
          next.classList.add('is-on');            // 크로스페이드
          tryPlay(next);
          setTimeout(function () { v.classList.remove('is-on'); }, 900);
        });
      });
    }
  }

  /* ---------- 2-a-2. 배너 영상 — 화면에 들어올 때 1회 재생하고 마지막 프레임 유지
                     (로고 리빌이라 루프하면 산만해진다) ---------- */
  var bannerVideo = document.getElementById('bannerVideo');
  if (bannerVideo) {
    if (reduce || !('IntersectionObserver' in window)) {
      bannerVideo.pause();                     // 모션 최소화: poster(끝 프레임)만 보여준다
    } else {
      var bio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          bio.unobserve(en.target);
          var pr = bannerVideo.play();
          if (pr && pr.catch) { pr.catch(function () {}); }
        });
      }, { threshold: 0.35 });
      bio.observe(bannerVideo);
    }
  }

  /* ---------- 2-b. 히어로 패럴랙스 — 스크롤에 따라 이미지가 천천히 따라오고
                     카피는 위로 빠지며 사라진다 (더마 톤: 이동량 작게) ---------- */
  var heroMedia = document.getElementById('heroMedia');
  var heroInner = hero && hero.querySelector('.inner');
  // [data-parallax="px"] — 화면을 지나는 동안 그 값만큼 스크롤보다 빠르게 위로 흐른다
  var floats = [].slice.call(document.querySelectorAll('[data-parallax]'));

  if ((heroMedia || floats.length) && !reduce) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        var vh = window.innerHeight;

        if (heroMedia) {
          var p = Math.min(y / vh, 1);               // 히어로 통과 진행도 0→1
          heroMedia.style.transform = 'translate3d(0,' + (p * 13).toFixed(2) + '%,0) scale(' + (1 + p * 0.06).toFixed(4) + ')';
          if (heroInner) {
            heroInner.style.transform = 'translate3d(0,' + (-p * 46).toFixed(1) + 'px,0)';
            heroInner.style.opacity = String(Math.max(1 - p * 1.5, 0));
          }
        }

        floats.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;   // 화면 밖이면 계산 생략
          var amount = parseFloat(el.dataset.parallax) || 0;
          // 요소 중심이 화면 중심에서 떨어진 정도 (-1 위 ~ +1 아래)
          // d가 줄어들수록(위로 갈수록) 음수 → 스크롤보다 빠르게 위로 흐른다
          var d = (r.top + r.height / 2 - vh / 2) / vh;
          el.style.transform = 'translate3d(0,' + (d * amount).toFixed(1) + 'px,0)';
        });
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }


  /* ---------- 3-b. 제품 상세(기본형) 갤러리 — 썸네일로 메인 이미지 교체 ---------- */
  var pdpMain = document.getElementById('pdpMain');
  var thumbs = document.querySelectorAll('.pdp-thumbs .thumb');
  if (pdpMain && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        if (!src || pdpMain.getAttribute('src') === src) return;
        pdpMain.setAttribute('src', src);
        thumbs.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      });
    });
  }

  /* ---------- 4. 제품 상세 — 스크롤 잠금 진행도 (toss.im 기법)
                 .pin-track 을 지나는 동안 0→1 을 --p 로 넣어주고, 값 보간은 CSS 가 한다.
                 data-steps 가 있으면 진행도를 그 수로 나눠 항목/이미지를 순차 활성화한다 ---------- */
  var tracks = [].slice.call(document.querySelectorAll('.pin-track'));
  if (tracks.length && !reduce) {
    var pinTicking = false;
    var syncTracks = function () {
      if (pinTicking) return;
      pinTicking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        tracks.forEach(function (tr) {
          var r = tr.getBoundingClientRect();
          // 트랙 상단이 pin 의 고정 위치에 닿은 순간부터, 트랙이 다 지나갈 때까지를 0→1 로.
          // pin 은 고정 헤더만큼 내려가 있으므로 그 오프셋과 실제 pin 높이를 써야 끝에서 정확히 1 이 된다
          var pin = tr.querySelector('.pin');
          var offset = pin ? (parseFloat(getComputedStyle(pin).top) || 0) : 0;
          var pinH = pin ? pin.offsetHeight : vh;
          var span = r.height - pinH;
          var p = span > 0 ? Math.min(Math.max((offset - r.top) / span, 0), 1)
                           : (r.top <= offset ? 1 : 0);
          tr.style.setProperty('--p', p.toFixed(4));

          var n = parseInt(tr.dataset.steps || '0', 10);
          if (!n) return;
          // 마지막 구간이 끝까지 유지되도록 n 구간으로 나눈다
          var i = Math.min(Math.floor(p * n), n - 1);
          if (tr.dataset.active === String(i)) return;
          tr.dataset.active = String(i);
          tr.querySelectorAll('[data-i]').forEach(function (el) {
            el.classList.toggle('on', el.dataset.i === String(i));
          });
        });
        pinTicking = false;
      });
    };
    window.addEventListener('scroll', syncTracks, { passive: true });
    window.addEventListener('resize', syncTracks);
    syncTracks();
  }

  /* ---------- 5. 수치 카운트업 — 화면에 들어올 때 한 번만 ---------- */
  var counters = [].slice.call(document.querySelectorAll('[data-count]'));
  if (counters.length) {
    var fmt = function (el, v) {
      var d = parseInt(el.dataset.decimals || '0', 10);
      return (el.dataset.prefix || '') + v.toFixed(d) + (el.dataset.suffix || '');
    };
    if (reduce || !('IntersectionObserver' in window)) {
      counters.forEach(function (el) { el.textContent = fmt(el, parseFloat(el.dataset.count)); });
    } else {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          cio.unobserve(en.target);
          var el = en.target;
          var target = parseFloat(el.dataset.count);
          var DUR = 1100;
          var t0 = performance.now();
          var tick = function (now) {
            var k = Math.min((now - t0) / DUR, 1);
            var eased = 1 - Math.pow(1 - k, 3);          // 끝에서 조용히 멈춘다
            el.textContent = fmt(el, target * eased);
            if (k < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.5 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  }
})();
